/* FILTERS */
export const GET_FILTERS = "GET_FILTERS"
export const GET_FILTERS_SUCCESS = "GET_FILTERS_SUCCESS"
export const GET_FILTERS_FAIL = "GET_FILTERS_FAIL"


export const APPLY_FILTER_PROPERTY = "APPLY_FILTER_PROPERTY"
export const APPLY_FILTER_PROPERTY_SUCCESS = "APPLY_FILTER_PROPERTY_SUCCESS"
export const APPLY_FILTER_PROPERTY_FAIL = "APPLY_FILTER_PROPERTY_FAIL"
export const APPLY_FILTER_BLOCK = "APPLY_FILTER_BLOCK"
export const APPLY_FILTER_BLOCK_SUCCESS = "APPLY_FILTER_BLOCK_SUCCESS"
export const APPLY_FILTER_BLOCK_FAIL = "APPLY_FILTER_BLOCK_FAIL"

export const RESTORE_FILTER_PROPERTY = "RESTORE_FILTER_PROPERTY"
